<template>
  <b-card>
    <b-form @reset="resetFilter">
      <fieldset>
        <b-form-group id="subscriptionContractId-group" :label="$t('subscription.subscriptionContractId')" label-for="subscriptionContractId">
          <b-form-input size="sm" id="subscriptionContractId" type="text" v-model="filter.subscriptionContractId" :disabled=isActiveProfileSet v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="customer-group" :label="$t('subscription.customer')" label-for="customer">
          <b-form-input size="sm" id="customer" type="text" v-model="filter.customer" :disabled=isActiveProfileSet v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="product-id-group" :label="$t('ean')" label-for="product-id">
          <b-form-input size="sm" id="product-id" type="text" v-model="filter.productId" v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="owner-group" :label="$t('subscription.ownerName')" label-for="owner">
          <b-form-input size="sm" id="owner" type="text" v-model="filter.owner" v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="buyer-group" :label="$t('subscription.buyerName')" label-for="buyer">
          <b-form-input size="sm" id="buyer" type="text" v-model="filter.buyer" v-on:keyup="onKeyup"/>
        </b-form-group>

        <b-form-group id="reference-group" :label="$t('subscription.reference')" label-for="reference">
          <b-form-input size="sm" id="reference" type="text" v-model="filter.reference" :disabled=isActiveProfileSet v-on:keyup="onKeyup"/>
        </b-form-group>

        <label for="createdFrom" v-text="$t('subscription.createdFrom')" />
        <b-form-datepicker size="sm" id="createdFrom" class="mb-2" reset-button locale="langCode" :label-reset-button="$t('reset')"
                           reset-button-variant="outline-secondary" :placeholder="$t('chooseADate')" v-model="filter.createdFrom"/>

        <label for="createdTo" v-text="$t('subscription.createdTo')" />
        <b-form-datepicker size="sm" id="createdTo" class="mb-4" reset-button locale="langCode" :label-reset-button="$t('reset')"
                           reset-button-variant="outline-secondary" :placeholder="$t('chooseADate')" v-model="filter.createdTo"/>

        <b-row>
          <b-col>
            <b-form-select size="sm" id="perPage" v-model="paging.perPage" :options="paging.perPageAlternatives"/>
          </b-col>
          <b-col>
            <b-button size="sm" type="reset" class="float-right">{{ $t('reset') }}</b-button>
          </b-col>
        </b-row>

        <b-form-group>
          <pagination v-bind:pagination="paging"/>
        </b-form-group>

      </fieldset>
    </b-form>
  </b-card>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrderFilter',
    extends: BaseComponent,

    computed: {
      ...mapGetters('subscriptions', ['filter', 'paging']),
      ...mapGetters('sessionStorage', ['isActiveProfileSet','activeProfile']),
    },

    methods: {
      resetFilter () {
        this.$store.dispatch('subscriptions/resetFilter')
        this.updateSubscriptions()
      },

      onKeyup (event) {
        if (event.which === 13) {
          this.updateSubscriptions()
        }
      },

      updateSubscriptions () {
        this.$store.dispatch('subscriptions/getSubscriptions')
      }
    },

    watch: {
      'paging.perPage': function () {
        this.updateSubscriptions()
      },
      'paging.currentPage': function () {
        this.updateSubscriptions()
      },
      'filter.createdFrom': function () {
        this.updateSubscriptions()
      },
      'filter.createdTo': function () {
        this.updateSubscriptions()
      },
      'isActiveProfileSet': function () {
        this.updateSubscriptions()
      }
    }
  }
</script>
